/**
 * handlers/milestone.ts
 * Milestone notification — confetti burst + avatar joy emotion.
 *
 * LAZY-LOAD REFACTOR:
 *   The static import of `updateAvatarEmotion` from `../avatar-3d` has been
 *   removed.  main.ts calls `registerAvatarEmotionCallback()` after the
 *   avatar chunk resolves, supplying the real function.  Until then the
 *   callback is a no-op — safe because milestones can only arrive during an
 *   active SSE stream, which only runs after the drawer is open and the
 *   avatar has already mounted.
 */

import { state } from '../state';

// ── LAZY-LOAD BRIDGE ──────────────────────────────────────────────────────────

let _updateAvatarEmotion: ((emotion: string, animate?: boolean) => void) | null = null;

/**
 * Called by main.ts after `import('./avatar-3d')` resolves.
 * Supplies the real `updateAvatarEmotion` function for milestone celebrations.
 */
export function registerAvatarEmotionCallback(
  fn: (emotion: string, animate?: boolean) => void,
): void {
  _updateAvatarEmotion = fn;
}

// ── Handler ───────────────────────────────────────────────────────────────────

/**
 * Fire confetti and briefly set the avatar to a joyful state.
 * Called whenever a milestone notification arrives (SSE `milestone` event).
 *
 * @param milestone  Optional milestone payload for future use.
 */
export function handleMilestoneNotification(milestone?: any) {
  if (typeof (window as any).confetti === 'function') {
    (window as any).confetti({
      particleCount: 120,
      spread:        80,
      origin:        { y: 0.6 },
    });
  }

  state.lastAvatarEmotion = state.currentAvatarEmotion;
  _updateAvatarEmotion?.('joy');

  setTimeout(() => {
    _updateAvatarEmotion?.((state.lastAvatarEmotion as string) || 'neutral');
  }, 4000);
}
